import styled from "styled-components";

export const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

export const AppContent = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  z-index: 1;
`;
